document.addEventListener("DOMContentLoaded", () => {
	const ALLOWED_EXTENSIONS = [
		"jpg",
		"jpeg",
		"png",
		"bmp",
		"pdf",
		"mp3",
		"wma",
		"wav",
	];
	const container = document.querySelector("#mfcf7_zl_multifilecontainer");

	if (!container) return;

	const findFormatTextElement = () => {
		const listItems = document.querySelectorAll(".complain-form__list-item");
		for (const item of listItems) {
			if (item.textContent.includes("Допустимые форматы:")) {
				return item;
			}
		}
		return null;
	};

	const getFileExtension = (fileName) => {
		const parts = fileName.split(".");
		return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
	};

	const isValidFileFormat = (file) => {
		const extension = getFileExtension(file.name);
		return ALLOWED_EXTENSIONS.includes(extension);
	};

	const getInvalidFiles = () => {
		const fileInputs = container.querySelectorAll('input[type="file"]');
		const invalidFiles = [];

		fileInputs.forEach((input) => {
			if (input.files && input.files.length > 0) {
				Array.from(input.files).forEach((file) => {
					if (!isValidFileFormat(file)) {
						invalidFiles.push(file);
					}
				});
			}
		});

		return invalidFiles;
	};

	const highlightError = (isError) => {
		const formatTextElement = findFormatTextElement();
		if (!formatTextElement) return;

		if (isError) {
			formatTextElement.classList.add("complain-form__list-item--error");
		} else {
			formatTextElement.classList.remove("complain-form__list-item--error");
		}
	};

	const validateFileFormats = (e) => {
		const form = e.currentTarget || e.target.closest(".wpcf7-form") || e.target;
		if (!form || form.tagName !== "FORM" || !form.contains(container)) {
			highlightError(false);
			return;
		}

		const invalidFiles = getInvalidFiles();

		if (invalidFiles.length > 0) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			highlightError(true);

			return false;
		}

		highlightError(false);
		return true;
	};

	const form = container.closest(".wpcf7-form");
	if (form) {
		form.addEventListener("submit", validateFileFormats, true);

		const fileInputs = container.querySelectorAll('input[type="file"]');
		fileInputs.forEach((input) => {
			input.addEventListener("change", () => {
				const invalidFiles = getInvalidFiles();
				if (invalidFiles.length === 0) {
					highlightError(false);
				} else {
					highlightError(true);
				}
			});
		});
	}
});
